import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as moment from "moment";
import { ExportPurchaserGQL } from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";

export interface DialogData {
  type: String;
}
@Component({
  selector: "report-print",
  templateUrl: "report-print.html",
  styleUrls: ['./report-print.scss']
})
export class ReportPrintDialog implements OnInit {
  status: any;
  formGrp: FormGroup;
  team: any;
  unitType: any;
  financier: any;
  currentDate: Date;
  maxStartDate: string;
  minEndDate: string;

  constructor(
    public dialogRef: MatDialogRef<ReportPrintDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public snackBarService: SnackBarService,
    private exportPurchaserGQL: ExportPurchaserGQL
  ) { }

  ngOnInit() {
    this.initForm();
    this.currentDate = new Date();
    this.maxStartDate = moment(this.currentDate)
      .subtract(1, "day")
      .format("YYYY-MM-DD")
      .toString();
  }

  initForm() {
    this.formGrp = new FormGroup({
      financier: new FormControl(),
      status: new FormControl(),
      team: new FormControl(),
      unitType: new FormControl(),
      startDate: new FormControl(),
      endDate: new FormControl(),
    });
  }

  downloadExcel(formIsValid) {
    if (!formIsValid) return;
    let startDate = moment(this.formGrp.controls.startDate.value).format("YYYY-MM-DD").toString();
    let endDate = moment(this.formGrp.controls.endDate.value).format("YYYY-MM-DD").toString();

    if (this.data.type == "PurchaserDemographic") {
      this.exportPurchaserGQL.fetch({ startDate: startDate, endDate: endDate })
        .subscribe(result => {
          if (result.errors) {
            this.snackBarService.showQueryError(result.errors);
            return;
          }
          this.decodeExcel(result?.data?.exportPurchaser);
        })
    } 
  }

  decodeExcel(data) {
    let prefix = "data:application/vnd.ms-excel;base64,";
    let file = document.createElement("a");
    let content = prefix + (data.base64 || data.file);
    file.setAttribute("href", content);
    file.setAttribute("download", (data.projectName || data.file_name));
    file.setAttribute("target", "_blank");
    file.setAttribute("id", "download");
    if (document.getElementById("download")) {
      document.body.removeChild(document.getElementById("downLoad"));
    }
    document.body.appendChild(file);
    file.click();
    document.body.removeChild(file);
  }

  onChangeStartDate(date) {
    this.minEndDate = moment(date, "DD-MM-YYYY").add(1, "day").format("YYYY-MM-DD").toString();
  }

  onChangeEndDate(date) {
    this.maxStartDate = moment(date, "DD-MM-YYYY").subtract(1, "day").format("YYYY-MM-DD").toString();
  }
}
